import config from "../conf/config.json";

// method: GET
export function getItemList() {
  const api = config.API_URL + "/pantry";
  console.log("getItemList(): api = ", api);
  return fetch(api)
    .then((data) => data.json())
    .catch((err) => JSON.stringify(err));
}

/* Fetch a single item from the pantry */
// method: GET
export function getItem(id) {
  const api = config.API_URL + "/pantry/" + id;
  return fetch(api).then((data) => data.json());
}

// method: POST
export function addItem(item) {
  const data = new URLSearchParams();
  for (const pair of item.entries()) {
    data.append(pair[0], pair[1]);
  }
  return fetch(config.API_URL + "/pantry", {
    method: "POST",
    body: data,
  }).then((data) => data.json());
}

// method: DELETE
export function deleteItem(id) {
  return fetch(config.API_URL + "/pantry/" + id, {
    method: "DELETE",
  }).then((res) => res.json());
}

// method: PATCH
export function setItemCount(id, cnt) {
  // console.log("setItemCount(): id=", id, " cnt=", cnt);
  let data = {
    id: parseInt(id),
    count: parseInt(cnt),
  };

  let bodyData = JSON.stringify(data);

  return fetch(config.API_URL + "/pantry/" + id, {
    headers: new Headers({ "content-type": "application/json" }),
    method: "PATCH",
    body: bodyData,
  }).then((res) => res.json());
}
